import React, { Component, createRef, Fragment } from 'react'
import { PostApplicationsModel, EditApplicationsModel } from './models'
import { ApplicationsList } from './ApplicationsList'
import { ApplicationsService } from './services/applications.service';
import { HttpResponse } from '../../../core';
import { Link, Route } from "react-router-dom";
import { ShowSuccessMessage, ShowException, HandleNotFoundResponse } from '../../../shared/helpers';
import { ButtonType } from '../../../shared/enums/button.enum'
import { Loader } from '../../../shared/loaders';
import { ApplicationsTabs } from './ApplicationsTabs'
import { NotFoundResponseArea } from '../../../shared/enums';
import { Modal } from 'react-bootstrap';

interface IProps {
    handleClose: Function,
    id?:number;
    isNew?:boolean;    
    updateApplication:Function
}
interface IState {
    applications?: PostApplicationsModel,
    editApplications?: EditApplicationsModel,
    id?: number,
    name?: string,
    type?: string,
    public?: boolean,
    applicationEnabled?: boolean,
    nameError?: string,
    typeError?: string,
    isShowtext?: string;
    isSave?: string;
    isSaving?: boolean;
}
export class ApplicationsFormPopup extends Component<IProps, IState> {
    //declaring service type
    private applicationsService: ApplicationsService;
    private nameRef: any;
    private typeRef: any;

    constructor(props:IProps) {
        super(props)
        this.applicationsService = new ApplicationsService();
        this.state = this.initialState;
        this.nameRef = createRef();
        this.typeRef = createRef();
        
    }

    handleClose = event => {
        event.preventDefault();
        this.props.handleClose();        
    }


    initialState: IState = {
        applications:{
            id: 0,
            name: "",
            type: "",
            public: false,
            enabled: false
        },
        id: 0,
        name: "",
        type: "",
        public: true,
        applicationEnabled: false,
        nameError: "",
        typeError:"",
        isShowtext: "New",
        isSave: "",
        isSaving: false
    } 
 
    componentDidMount() {
        if (!this.props.isNew) {
            this.setState({ id: this.props.id, isShowtext: "Edit" }, () => {
                this.loadData();
            });
        }
        
    }

    loadData() {

        this.applicationsService.editApplications(this.props.id)
            .then((res: HttpResponse<EditApplicationsModel>) => {
                if (res && res.result) {
                    this.setState({
                        id: res.result?.id,
                        name: res.result?.name,
                        type: res.result?.type,
                        public: res.result?.public,
                        applicationEnabled: res.result?.enabled,
                    },()=>{
                       
                    });
                }
            })
            .catch(ex => {
                HandleNotFoundResponse(ex,NotFoundResponseArea.Applications,this.props)
            });
    }

    postData(application: PostApplicationsModel) {
        this.setSavingFlag(true);
        this.applicationsService.postApplications(application)
            .then((res: HttpResponse<PostApplicationsModel>) => {
                this.setSavingFlag(false);
                if (res && res.result) {
                    this.setState({
                        applications: res.result,
                        id: res.result.id
                    }, () => {
                        ShowSuccessMessage("Application successfully created.");
                        if (this.state.isSave === ButtonType.Save) {
                            this.setState(this.initialState);
                            this.props.updateApplication(true,this.state.name,this.state.id);
                            this.props.handleClose();
                        }
                        
                    });

                }
            }, () => {
                this.setSavingFlag(false);
            });;
    }

    updateData(application: PostApplicationsModel) {
        this.setSavingFlag(true);
        this.applicationsService.updateApplications(application)
            .then((res: HttpResponse<PostApplicationsModel>) => {
                this.setSavingFlag(false);
                if (res && res.result) {
                    this.setState({
                        applications: res.result
                    }, () => {
                        ShowSuccessMessage("Application Successfully Updated.");
                        if (this.state.isSave === ButtonType.Save) {
                            this.setState(this.initialState);
                            this.props.updateApplication(true,this.state.name,this.state.id);
                            this.props.handleClose();
                        }
                    });

                }
            }, () => {
                this.setSavingFlag(false);
            });
    }


  
 
    handleChange = (event: any) => {
         
        const isCheckbox = event.target.type === "checkbox";
    
        this.setState({
          [event.target.name]: isCheckbox
            ? event.target.checked
            : event.target.value,
        });

        if (event.target.name=="name" && this.nameRef.current.value) {
            this.setState({ nameError: "" });
          }
          if (event.target.name=="type" && this.typeRef.current.value) {
            this.setState({ typeError: "" });
          }

      };


    validate = () => {
        let nameError = "";
        let typeError = "";
        if (!this.nameRef.current.value) {
            nameError = "Name can't be blank";
        }
        if (!this.state.type) {
            typeError = "Type can't be blank";
        }

        if (nameError || typeError) {
            this.setState({ 
                nameError: nameError,
                typeError:typeError
            })
            return false;
        }

        else {
            nameError = "";
            typeError = "";
            this.setState({ nameError: nameError, 
                typeError:typeError
            })
            return true;
        }
    }

    handleSubmit = event => {
        event.preventDefault();
        const isValid = this.validate();
        let applicationsData: PostApplicationsModel = {
            id: this.state.id,
            name: this.state.name,
            type: this.state.type,
            public: this.state.public,
            enabled: this.state.applicationEnabled,
        };
        if (isValid) {
            if (applicationsData.id === 0) {
                this.postData(applicationsData);
            }
            else {
                this.updateData(applicationsData)
            }
        }
    }

    handleClick = (event) => {
        this.setState({ isSave: event.target.value },()=>{
            this.props.updateApplication(true,this.state.name,this.state.id);
        })
    }
    private setSavingFlag(saving: boolean) {
        this.setState({ isSaving: saving });
    }



    render() {
        return (
            <Fragment>
                <form onSubmit={this.handleSubmit}>
                <Modal.Header closeButton onClick={this.handleClose}>
                    </Modal.Header>
                    <Modal.Body>
                    <input type="hidden" value={this.state.id} />
                    <div>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4>{this.state.isShowtext} Applications{this.state.name && <span> '{this.state.name}'</span>}</h4>                            
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-body">
                                       <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group p-3 shadow-sm">
                                                    <label>Name<span className=" text-danger">*</span></label>
                                                    <input type="text" maxLength={255}  ref={this.nameRef} name="name" value={this.state.name} onChange={this.handleChange} className={!this.state.nameError ? 'form-control' : 'form-control  is-invalid'} />
                                                    <div className="invalid-feedback">
                                                        {this.state.nameError}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                {this.state.id ==0 &&<div className="form-group p-3 shadow-sm">
                                                    <label>Type<span className=" text-danger">*</span> </label>
                                                    <input type="text" maxLength={255}  ref={this.typeRef} name="type" value={this.state.type} onChange={this.handleChange} className={!this.state.typeError ? 'form-control' : 'form-control  is-invalid'} />
                                                    <div className="invalid-feedback">
                                                        {this.state.typeError}
                                                    </div>
                                                    <small>You should not normally change this. It gets set by the developer the first time the application code is pushed.</small>
                                                </div>
                                                }
                                                {this.state.id != 0 && 
                                                <div className="form-group shadow-sm p-3">
                                                    <label>Type</label>
                                                   <div><span className="badge badge-light"> {this.state.type}</span></div>
                                                    <small>You should not normally change this. It gets set by the developer the first time the application code is pushed.</small>
                                                </div>
                                                }
                                            </div>
                                        </div>

                                        
                                        <div className="row mt-4">
                                            <div className="col">
                                                <div className="form-group  shadow-sm p-3 mb-4">
                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox"  name="public" checked={this.state.public} onChange={this.handleChange} className="custom-control-input" id="public" />
                                                    <label className="custom-control-label" htmlFor="public">Public</label>
                                                    </div>
                                                        <small>If this is true, this app will be visible in the app marketplace.</small>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="form-group  shadow-sm p-3 mb-4">
                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" name="applicationEnabled" checked={this.state.applicationEnabled} className="custom-control-input" onChange={this.handleChange} id="applicationEnabled" />
                                                    <label className="custom-control-label" htmlFor="applicationEnabled">Enabled</label>
                                                    </div>
                                                        <small>If this is false, no installed instances of this application will run.</small>
                                                </div>
                                                
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>

                        </div>


                        <div className="text-center mt-3 mb-4">
                                <button type="button" className="btn btn-lg btn-default" onClick={this.handleClose}>{ButtonType.Cancel}</button>
                                {!this.state.isSaving && <Fragment>
                                    <input type="submit" className="btn btn-lg btn-primary  ml-3" onClick={this.handleClick} value={ButtonType.Save} />                                    
                                </Fragment>
                                }
                                <Loader loading={this.state.isSaving} marginBottom="0px" marginTop="8px" width="368px" ></Loader>
                            </div>
                    </div>
                    </Modal.Body>
                </form>
                <Route path="/application/list" component={ApplicationsList} />
            </Fragment>
        )
    }
}